<template>
  <div></div>
</template>

<script>
import { bindWx } from "@/api/newApi";
import store from "store";
import base from "../../../utils/base";
import { Toast } from "vant";
export default {
  data() {
    return {
      code: 0,
      winUrl: "",
    };
  },
  mounted() {
    // this.login();
    // 检测连接有无code
    console.log(store.get("latestUrl"));
    let latestUrl = store.get("latestUrl").name;
    let code = this.getvar(latestUrl, "code");
    if (!code) {
      var redirect_url = this.getRedirectUrl();
      // 无code跳转到微信授权页面
      let authUrl =
        "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
        base.appid +
        "&redirect_uri=" +
         encodeURIComponent(redirect_url) +
        "&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect";
      window.location.href = authUrl;
    } else {
      this.code = code;
      this.bind();
    }
  },
  methods: {
    getRedirectUrl() {
      let redirect_url = base.client + "/#/admin/bind_wechat?type=bind_wechat";
      return redirect_url;
    },
    bind() {
      bindWx(this.code).then((res) => {
        if (res.message.code == -5) {
          Toast(res.message.message);
        } else {
          Toast("绑定成功");
          this.$router.replace("/admin/mine");
        }
      });
    },
    getvar(url, par) {
      var urlsearch = url.split("?");
      if (!urlsearch[1]) {
        return false;
      }
      var pstr = urlsearch[1].split("&");
      for (var i = pstr.length - 1; i >= 0; i--) {
        var tep = pstr[i].split("=");
        if (tep[0] === par) {
          return tep[1];
        }
      }
      return false;
    },
    getUrlCode() {
      // 截取url中的code方法
      var url = location.search;
      this.winUrl = url;
      var theRequest = new Object();
      if (url.indexOf("?") != -1) {
        var str = url.substr(1);
        var strs = str.split("&");
        for (var i = 0; i < strs.length; i++) {
          theRequest[strs[i].split("=")[0]] = strs[i].split("=")[1];
        }
      }
      return theRequest;
    },
  },
};
</script>

<style></style>
